// extracted by mini-css-extract-plugin
module.exports = {"grid":"blog_grid___7F9r","articleSection":"blog_articleSection__41OK_","post":"blog_post__JNkE9"};